import axios from "axios";
import { LOCAL_STORE_IP_ADDRESS } from "../constants";

export async function getIP() {
  try {
    const res = await axios.get("https://api.ipify.org/?format=json");
    const { ip } = res.data as any;
    localStorage.setItem(LOCAL_STORE_IP_ADDRESS, String(ip).replace(/\D/g, ""));

  } catch (error) {
    console.error(error);
  }
}
